import Typography from '@mui/material/Typography';
import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import { LugasErrorCode } from '../../../types/status';
import Prompt from '../../Prompt/Prompt';

import {
  TXTSRV_Please_try_again_laterX,
  TXTWCL_Account_declined,
  TXTWCL_Okay,
  TXTWCL_Please_contact_LUGAS_for_more__ELL,
  TXTWCL_SorryX_an_account_already_exis_ELL,
  TXTWCL_SorryX_we_cannot_complete_your_ELL,
  TXTWCL_SorryX_we_cannot_complete_your_ELL_1,
  TXTWCL_You_need_to_set_your_Cross_Ope_ELL,
  TXTWCL_You_will_need_to_provide_this__ELL,
  TXTWCL_Your_player_ID_isX_N0
} from './LugasErrors.messages.json';

interface Props {
  onClose(): void;
  code: LugasErrorCode;
}

const getContent = (code: LugasErrorCode, userIntId: number | undefined) => {
  let contentMessage;

  switch (code) {
    case LugasErrorCode.ERR_LUGAS_UNAVAILABLE:
      contentMessage = (
        <Typography>
          <Translation {...TXTWCL_SorryX_we_cannot_complete_your_ELL} />{' '}
          <Translation {...TXTSRV_Please_try_again_laterX} />
        </Typography>
      );
      break;
    case LugasErrorCode.ERR_LUGAS_LIMIT_REQUIRED:
      contentMessage = (
        <Typography>
          <Translation {...TXTWCL_You_need_to_set_your_Cross_Ope_ELL} />
        </Typography>
      );
      break;
    case LugasErrorCode.ERR_LUGAS_DUPLICATE_PLAYER_ID:
      contentMessage = (
        <>
          <Typography>
            <Translation {...TXTWCL_SorryX_an_account_already_exis_ELL} />{' '}
            <Translation {...TXTWCL_Please_contact_LUGAS_for_more__ELL} />
            <br />
          </Typography>
          <Typography>
            <Translation
              tagName="span"
              {...TXTWCL_Your_player_ID_isX_N0}
              values={{
                0: <b> {userIntId} </b>
              }}
            />
            <br />
            <Translation {...TXTWCL_You_will_need_to_provide_this__ELL} />
          </Typography>
        </>
      );
      break;
    case LugasErrorCode.ERR_LUGAS_REQUEST_FAILED:
      contentMessage = (
        <Typography>
          <Translation {...TXTWCL_SorryX_we_cannot_complete_your_ELL_1} />{' '}
          <Translation {...TXTSRV_Please_try_again_laterX} />
        </Typography>
      );
      break;
  }

  return contentMessage;
};

const LugasErrors: React.FC<Props> = ({ onClose, code }) => {
  const userIntId = useSelector(select.account.getUserIntId);
  const content = getContent(code, userIntId);

  return (
    <Prompt
      onClose={onClose}
      variant="default"
      title={{ translation: TXTWCL_Account_declined }}
      onPrimaryButtonClick={onClose}
      primaryButton={{ translation: TXTWCL_Okay }}
    >
      {content}
    </Prompt>
  );
};

export default LugasErrors;
